<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    @close="$emit('close')"
  >
    <div class="mx-1">
      <span
        class="-mt-5 mb-4 flex w-max cursor-pointer text-left text-neutral-subtle"
        @click="handleResetSort"
      >
        Reset
      </span>
      <h4 class="text-left text-2xl text-dark-blue">Sort</h4>

      <div>
        <round-radio-button
          item="Latest"
          name="sort"
          value="latest"
          :show="true"
          :checked="selectedSort === 'latest'"
          :handle-click="($event) => handleSelectSort($event, 'latest')"
        />
        <round-radio-button
          item="Broker"
          name="sort"
          value="broker"
          :show="true"
          :checked="selectedSort === 'broker'"
          :handle-click="($event) => handleSelectSort($event, 'broker')"
        />
        <round-radio-button
          item="Expiration"
          name="sort"
          value="expiration"
          :show="true"
          :checked="selectedSort === 'expiration'"
          :handle-click="($event) => handleSelectSort($event, 'expiration')"
        />
        <round-radio-button
          item="Amount"
          name="sort"
          value="amount"
          :show="true"
          :checked="selectedSort === 'amount'"
          :handle-click="($event) => handleSelectSort($event, 'amount')"
        />
      </div>

      <button-main
        class="mb-2 mt-4 text-1md font-medium !text-steel-1100"
        :disabled="!selectedSort"
        @click="handleApplySort"
      >
        Apply
      </button-main>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { ref, onBeforeMount, defineProps, defineEmits } from 'vue';
// import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BottomSheet from '@/components/BottomSheet.vue';
import RoundRadioButton from '@/components/RoundRadioButtonLoads.vue';
import ButtonMain from '@/components/Button.vue';

defineProps({
  visible: Boolean,
});

const emit = defineEmits(['close']);

// const store = useStore();
const router = useRouter();

const selectedSort = ref('');

onBeforeMount(() => {
  const querySort = router.currentRoute.value.query?.sort;

  if (querySort) {
    selectedSort.value = querySort;
  }
});

const handleSelectSort = (item, value) => {
  selectedSort.value = value;
};

const handleResetSort = () => {
  selectedSort.value = '';
  const existingSort = router.currentRoute.value.query?.sort;
  const existingQueries = router.currentRoute.value.query;

  // eslint-disable-next-line no-unused-vars
  const { sort, ...rest } = existingQueries || {};

  if (existingSort) {
    // router.push({
    //   query: {
    //     ...rest,
    //   },
    // });
  }

  emit('close');
};

const handleApplySort = () => {
  const existingSort = router.currentRoute.value.query?.sort;
  // const existingQueries = router.currentRoute.value.query;
  console.log('existing', existingSort, '/', selectedSort.value);

  if (existingSort !== selectedSort.value) {
    // store.commit('loads/setLoading', true);
    // router.push({
    //   query: {
    //     // page: 1,
    //     ...existingQueries,
    //     sort: selectedSort.value,
    //   },
    // });
  }

  emit('close');
};
</script>
